<template>
  <div class="simple-suggest" >
    <vue-simple-suggest ref="vss"
      :class="[{'is-small': isSmall, 'items-right-align': itemsRightAlign},]"
      v-model="computed_value"
      @input="input"
      @select="select"
      :list="list"
      :filter-by-query="true"
      :max-suggestions=0
      :min-length=0
      :controls="{
        selectionUp: [38],
        selectionDown: [40],
        select: [13],
        showList: [40],
        hideList: [27],
        autocomplete: [32, 13]
      }"
    >

      <!-- Filter by input text to only show the matching results -->
      <input :class="['input', {'is-small': isSmall}]" :placeholder="placeholder" type="text">
    </vue-simple-suggest>
  </div>
</template>

<style>
  .vue-simple-suggest > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  overflow-x:hidden;

}

.vue-simple-suggest.designed {
  position: relative;
}

.vue-simple-suggest.designed, .vue-simple-suggest.designed * {
  box-sizing: border-box;
}

.vue-simple-suggest.designed .input-wrapper input {
  transition: all .1s;
  transition-delay: .05s
}

.vue-simple-suggest.designed .suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  top: calc(100% + 1px);
  max-width: 150%;
  border-radius: 3px;
  border: 1px solid #aaa;
  background-color: #fff;
  opacity: 1;
  z-index: 1000;
}

.vue-simple-suggest.designed.items-right-align .suggestions {
  left: auto;
  right: 0;
}

.vue-simple-suggest.designed.items-left-align .suggestions {
  left: 0;
  right: auto;
}

.vue-simple-suggest.designed .suggestions .suggest-item {
  cursor: pointer;
  user-select: none;
}

.vue-simple-suggest.designed .suggestions .suggest-item,
.vue-simple-suggest.designed .suggestions .misc-item {
  padding: 5px 10px;
  max-height: 2em;
  text-overflow: clip;
  overflow:hidden;
  white-space: nowrap;
  word-wrap: none;
}

.vue-simple-suggest.designed.is-small .suggestions .suggest-item,
.vue-simple-suggest.designed.is-small .suggestions .misc-item {
  font-size: .75rem;
}


.vue-simple-suggest.designed .suggestions .suggest-item.selected
{
  background-color: #f5f5f5 !important;
  color: #0b0b0b !important;
  
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: #3298dc;
  color: #fff;
}


</style>

<script>
import VueSimpleSuggest from '@vojtechlanka/vue-simple-suggest'
// import 'vue-simple-suggest/dist/styles.css' // Optional CSS

export default {
  name: 'InputAutosuggest',
  components: {
    VueSimpleSuggest
  },
  props: [
    'list',
    'placeholder',
    'isSmall',
    'itemsRightAlign',
    'value',
  ],
  computed:{
    computed_value:{
      get: function(){
        return this.value
      },
      set: function(){
        // Value is set by emmitting input/select events
        // but defining setter function squashes warnings
      }
      
      
    }
  },
  data: function(){
    return {
      // isSmall: false,
    };
  },
  created: function(){
    
  },
  mounted: function(){
    
  },
  watch: {
    value: function(){
      this.$refs.vss.setText(this.value)
    },
  },
  methods: {
    input: function(e){
      this.$emit('input', e)
    },
    select: function(e){
      this.$emit('select', e)
    }
  }
};

</script>
